import { render, staticRenderFns } from "./AdminSystemParameters.vue?vue&type=template&id=3c0fec4c&scoped=true&"
import script from "./AdminSystemParameters.ts?vue&type=script&lang=ts&"
export * from "./AdminSystemParameters.ts?vue&type=script&lang=ts&"
import style0 from "./AdminSystemParameters.vue?vue&type=style&index=0&id=3c0fec4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0fec4c",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
